// extracted by mini-css-extract-plugin
export default {"horizontalDivider":"Divider_horizontalDivider__krStq","verticalDivider":"Divider_verticalDivider__Y+O4a"};